import { Box, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useSelector } from "react-redux";

const NoFraudDetected = () => {
  const brandDisplayName = useSelector(
    (state: any) => state?.deepView?.deepViewData?.period?.brand_display_name,
  );

  return (
    <>
      <Box
        sx={{
          border: "1px solid #2E7D3280",
          borderRadius: "8px",
          backgroundColor: "#2E7D320A",
          p: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <CheckIcon
            sx={{
              color: "#1B5E20",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#1B5E20",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            No Fraud Detected
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#1B5E20",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          No fraud users were identified for{" "}
          <strong>{brandDisplayName}</strong> for the selected period. The{" "}
          <strong> fraud_brand_performance_id</strong> is NULL or -1, meaning no
          fraud correction was applied to this brand's values.
        </Typography>
      </Box>
    </>
  );
};

export default NoFraudDetected;
